import { Heading } from "@/components/ui/heading.jsx";
import { Head } from "@inertiajs/react";
import pageTitle from "@/utils/pageTitle.js";

export default function () {
  return (
    <div className={"container mx-auto space-y-8 py-16 px-4 xl:px-0"}>
      <Head title={pageTitle("F.A.Q.")}></Head>
      <div className="prose prose-lg max-w-none">
        <Heading size={"h1"}>F.A.Q.</Heading>
      </div>
    </div>
  );
}
